import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';

import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_DATA_CLEAR,
  ALL_INCIDENTS_FETCH_DATA,
  ALL_INCIDENTS_TABLE_ACTION_SUCCESS,
  ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_ERROR,
  ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_FAILURE,
  ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_REQUEST,
  ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_SUCCESS,
} from '../../../../actions/actionTypes.js';

const updateIncidents = (state, action, updateCallback) => {
  const newState = cloneDeep(state);
  const [
    actionAssetId,
    actionDetectionLinkId,
  ] = action.payload.sortedParameters;
  get(newState, 'data.content', [])
    .filter(
      ({
        incident: {
          detectionLink: { detectionLinkId },
        },
        assetId,
      }) =>
        detectionLinkId === actionDetectionLinkId && assetId === actionAssetId
    )
    .forEach(updateCallback);
  return newState;
};

export const additionalActionsReducer = (state, action) => {
  let link;
  let newState;
  const incidentId = action.payload?.incidentId;
  const incidentType = action.payload?.incidentType;
  switch (action.type) {
    case ALL_INCIDENTS_DATA_CLEAR: {
      if (get(state, 'data.content', null)) {
        const newState = cloneDeep(state);
        newState.data.totalElements = 0;
        newState.data.totalPages = 0;
        newState.data.content = [];
        return newState;
      } else {
        return state;
      }
    }

    case ALL_INCIDENTS_TABLE_ACTION_SUCCESS: {
      const isBookmark = action?.payload?.isBookmark ?? false;

      let fncallback = () => {};
      if (isBookmark) {
        fncallback = incident => {
          incident.watching = !incident.watching;
        };
      }

      return updateIncidents(state, action, fncallback);
    }

    case ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_REQUEST:
      newState = cloneDeep(state);
      link = newState.data?.content?.find(
        incident => incident.incidentId === incidentId
      );
      link.incident[incidentType].isLoading = true;
      return newState;

    case ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_SUCCESS: {
      const { response } = action.payload;
      newState = cloneDeep(state);
      link = newState.data?.content?.find(
        incident => incident.incidentId === incidentId
      );
      link.incident[incidentType].deindexation = response.data || [];
      link.incident[incidentType].isLoading = false;
      return newState;
    }
    case ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_ERROR:
    case ALL_INCIDENTS_TABLE_FETCH_DEINDEXATION_BY_LINK_FAILURE: {
      newState = cloneDeep(state);
      link = newState.data?.content?.find(
        incident => incident.incidentId === incidentId
      );
      link.incident[incidentType].deindexation = [];
      link.incident[incidentType].isLoading = false;
      return newState;
    }
    default:
      return state;
  }
};

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FETCH_DATA,
  additionalActionsReducer
);
